import {ReactNode} from 'react'
import countries from 'i18n-iso-countries'

import {enGB} from './locales/en-GB'
import {ptPT} from './locales/pt-PT'

export enum Languages {
  enGB = 'en-GB',
  ptPT = 'pt-PT'
}

countries.registerLocale(require('i18n-iso-countries/langs/en.json'))
countries.registerLocale(require('i18n-iso-countries/langs/pt.json'))

// PT is the default translation. By exporting the type, we can use it in other languages to ensure that we have all
// the keys translated. Check usage on ./en-GB.ts.
type TranslationKeys = keyof typeof ptPT
type TranslationValues = typeof ptPT[TranslationKeys]
export type Translations = {[key in TranslationKeys]: TranslationValues}

export type LanguageConfig = {
  localeCode: Languages,
  label: string,
  translations: Translations
}

export const defaultLocaleCodes: {[key: string]: Languages} = {
  en: Languages.enGB,
  pt: Languages.ptPT,
  others: Languages.ptPT
}

export const languageConfig: Array<LanguageConfig> = [
  {
    localeCode: Languages.ptPT,
    label: 'Português',
    translations: ptPT
  },
  {
    localeCode: Languages.enGB,
    label: 'English',
    translations: enGB
  }
]

export const defaultRichTextElements = {
  b: (text: ReactNode | ReactNode[]) => <strong>{text}</strong>,
  i: (text: ReactNode | ReactNode[]) => <em>{text}</em>
}
